import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getDashboard = state => state.dashboard

export const getDashboardStats = createSelector(
  getDashboard,
  propOr([], 'dashboard')
)

export const getDashboardLoading = createSelector(
  getDashboard,
  propOr(false, 'dashboardLoading')
)

export const getLastSearchedBps = createSelector(
  getDashboard,
  propOr([], 'lastSearchedBps')
)

export const getLastSearchedFiles = createSelector(
  getDashboard,
  propOr([], 'lastSearchedFiles')
)

export const getLastViewedBps = createSelector(
  getDashboard,
  propOr([], 'lastViewed')
)
